import { useQuery } from "@tanstack/react-query";
import { MapPin, ShieldCheck, Heart } from "lucide-react";
import api from "@/lib/api";
import { PageHero } from "./Services";

export default function About() {
  const { data: content } = useQuery({ queryKey: ["content"], queryFn: () => api.get("/content").then(r => r.data.content) });
  const about = content?.about || {};
  return (
    <div>
      <PageHero label="About" title="Local. Affordable. Honest Tech Help." subtitle="Thomason Digital Works — Southern Illinois' partner for websites, PC help, and automation." />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <p className="text-lg text-slate-700 leading-relaxed">{about.body}</p>
        <div className="mt-10 grid sm:grid-cols-3 gap-5">
          {[[MapPin, "Local", "Proudly serving Salem, Centralia & Southern Illinois."], [Heart, "Affordable", "Fair, upfront pricing with no surprises."], [ShieldCheck, "Honest", "We tell you the truth about your tech — always."]].map(([Ico, t, d], i) => (
            <div key={i} className="rounded-xl border border-slate-200 p-6">
              <div className="h-11 w-11 rounded-lg bg-gradient-to-br from-electric to-tech text-white grid place-items-center mb-3"><Ico className="h-5 w-5" /></div>
              <h3 className="font-heading font-semibold text-navy">{t}</h3>
              <p className="mt-1 text-sm text-slate-600">{d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
